<template>
  <v-carousel
    height="250"
    show-arrows-on-hover
    hide-delimiters
  >
    <v-carousel-item
      v-for="(slide, i) in slides"
      :key="i"
    >
      <v-sheet
        height="100%"
        color="white"
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
        <div v-for="(item,k) in slide" :key="k">
          <iframe style="width:120px;height:240px;"
          marginwidth="0"
          marginheight="0"
          scrolling="no"
          frameborder="0"
          :src="item"></iframe>
        </div>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>
<script>

export default {
  name: 'Advertising',
  data() {
    return {
      slides: [
      ],
    };
  },
  mounted() {
    const db = this.$firebase.firestore();
    this.slides.push([]);
    if (this.$advetising !== undefined) {
      this.slides = this.$advetising;
      console.log('foi');
      return;
    }
    db.collection('Advertising').limit(100).get()
      .then((docs) => {
        docs.forEach((doc) => {
          const ad = doc.data();
          if (this.slides[this.slides.length - 1].length < 2) {
            this.slides[this.slides.length - 1].push(ad.link);
          } else {
            this.slides.push([ad.link]);
          }
        });
        this.$advetising = this.slides;
      },
      (err) => {
        console.log(err);
      });
  },
};
</script>
